import {get, post} from '../index'

export default {
  // 商品开关
  updateGoodsParameterStatus (query) {
    return post('/shop/admin/AdminShopGoods/goodsParameterStatus', query)
  },
  // 商品参数回写
  getGoodsParameterEdit (query) {
    return get('/shop/admin/AdminShopGoods/goodsParameterEdit', query)
  },
  // 商品参数编辑
  updateGoodsParameterEdit (query) {
    return post('/shop/admin/AdminShopGoods/goodsParameterEdit', query)
  },
  //   新增商品参数
  addGoodsParameterAdd (query) {
    return post('/shop/admin/AdminShopGoods/goodsParameterAdd', query)
  },
  // 查看申请详情
  getGetDistributorInfo (query) {
    return get('/shop/admin/AdminSellingProfit/getDistributorInfo', query)
  },
  // 审核申请
  updateExDistributor (query) {
    return get('/shop/admin/AdminSellingProfit/exDistributor', query)
  },
  //   获取商品参数列表
  getGoodsParameterList (query) {
    return post('/shop/admin/AdminShopGoods/goodsParameter', query)
  },
  // 获取申请列表
  getDistributorList (query) {
    return get('/shop/admin/AdminSellingProfit/getDistributor', query)
  },
  // 获取申请统计数量
  getDistributorCount () {
    return get('/shop/admin/AdminSellingProfit/getDistributorCount')
  },
  // 添加模板
  goodsParameterTemplateAdd (query) {
    return post('/shop/admin/AdminShopGoods/goodsParameterTemplateAdd', query)
  },
  // 获取模板列表
  getGoodsParameterTemplateList (query) {
    return post('/shop/admin/AdminShopGoods/goodsParameterTemplate', query)
  },
  // 获取下拉选择参数
  getParameterTemplateList (query) {
    return post('/shop/admin/AdminShopGoods/getParameterList', query)
  },
  // 模板是否开启
  updateGoodsParameterTemplateStatus (query) {
    return post('/shop/admin/AdminShopGoods/goodsParameterTemplateStatus', query)
  },
  // 获取模板编辑
  getGoodsParameterTemplateEdit (query) {
    return post('/shop/admin/AdminShopGoods/goodsParameterTemplateEdit', query)
  },
  // 提交编辑数据
  updateGoodsParameterTemplateEdit (query) {
    return post('/shop/admin/AdminShopGoods/goodsParameterTemplateEdit', query)
  },
  // 获取增加商品下拉模板数据
  getGoodsTemplateOptions (query) {
    return get('/shop/admin/AdminShopGoods/parameterTemplateList', query)
  },
  // 根据模板id 获取模板数据
  getTemplateInfo (query) {
    return post('shop/admin/AdminShopGoods/getTemplateInfo', query)
  },
  // 删除二级属性判断
  isGoodsParameterTemplateDel (query) {
    return post('/shop/admin/AdminShopGoods/goodsParameterTemplateDel', query)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/distribution.js